import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as notesActions from 'containers/ProjectTools/Notes/actions';
import * as settingsActions from 'containers/Settings/Projects/actions';

import NoteTemplates from './NoteTemplates';

const NoteTemplatesIndex = () => {
  const templates = useSelector((state) => state.projectTools.notes?.templates || []);
  const folders = useSelector((state) => state.settings.projectSettings.noteTemplateFolders);

  const dispatch = useDispatch();
  const {
    getNotesTemplates,
    reorderNoteTemplates,
    createNoteTemplate,
    getNoteTemplateFolders,
    createNoteTemplateFolder,
    updateNoteTemplateFolder,
    deleteNoteTemplateFolder,
    reorderNoteTemplateFolders,
  } = bindActionCreators({ ...notesActions, ...settingsActions }, dispatch);

  useEffect(() => {
    getNotesTemplates();
    getNoteTemplateFolders();
  }, []);

  return (
    <NoteTemplates
      folders={folders}
      templates={templates}
      createNoteTemplateFolder={createNoteTemplateFolder}
      createNoteTemplate={createNoteTemplate}
      reorderNoteTemplates={reorderNoteTemplates}
      updateNoteTemplateFolder={updateNoteTemplateFolder}
      deleteNoteTemplateFolder={deleteNoteTemplateFolder}
      reorderNoteTemplateFolders={reorderNoteTemplateFolders}
    />
  );
};

export default NoteTemplatesIndex;
